import { FormFieldRadioGroup as ChordsFormFieldRadioGroup } from '~/chords/FormField';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export const FormFieldRadioGroup = withClassNameHoc(ChordsFormFieldRadioGroup);
